import { defineComponent as Z, openBlock as o, createElementBlock as e, mergeProps as d, unref as l, renderSlot as i, createElementVNode as n, createCommentVNode as p } from "vue";
import { useScalarIcon as u } from "../hooks/useScalarIcon.js";
const g = { key: 0 }, f = { key: 1 }, h = { key: 2 }, k = { key: 3 }, M = { key: 4 }, w = { key: 5 }, y = {
  name: "ScalarIconDotsThreeCircle"
}, b = /* @__PURE__ */ Z({
  ...y,
  props: {
    label: {},
    weight: {}
  },
  setup(m) {
    const r = m, { bind: s, weight: a } = u(r);
    return (A, t) => (o(), e("svg", d({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, l(s)), [
      i(A.$slots, "default"),
      l(a) === "bold" ? (o(), e("g", g, t[0] || (t[0] = [
        n("path", { d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm0,192a84,84,0,1,1,84-84A84.09,84.09,0,0,1,128,212Zm-16-84a16,16,0,1,1-16-16A16,16,0,0,1,112,128Zm64,0a16,16,0,1,1-16-16A16,16,0,0,1,176,128Z" }, null, -1)
      ]))) : l(a) === "duotone" ? (o(), e("g", f, t[1] || (t[1] = [
        n("path", {
          d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm56-88a12,12,0,1,1-12-12A12,12,0,0,1,184,128Zm-44,0a12,12,0,1,1-12-12A12,12,0,0,1,140,128Zm-44,0a12,12,0,1,1-12-12A12,12,0,0,1,96,128Z" }, null, -1)
      ]))) : l(a) === "fill" ? (o(), e("g", h, t[2] || (t[2] = [
        n("path", { d: "M128,24A104,104,0,1,0,232,128,104.13,104.13,0,0,0,128,24ZM84,140a12,12,0,1,1,12-12A12,12,0,0,1,84,140Zm44,0a12,12,0,1,1,12-12A12,12,0,0,1,128,140Zm44,0a12,12,0,1,1,12-12A12,12,0,0,1,172,140Z" }, null, -1)
      ]))) : l(a) === "light" ? (o(), e("g", k, t[3] || (t[3] = [
        n("path", { d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm0,192a90,90,0,1,1,90-90A90.1,90.1,0,0,1,128,218Zm10-90a10,10,0,1,1-10-10A10,10,0,0,1,138,128Zm-44,0a10,10,0,1,1-10-10A10,10,0,0,1,94,128Zm88,0a10,10,0,1,1-10-10A10,10,0,0,1,182,128Z" }, null, -1)
      ]))) : l(a) === "regular" ? (o(), e("g", M, t[4] || (t[4] = [
        n("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm12-88a12,12,0,1,1-12-12A12,12,0,0,1,140,128Zm44,0a12,12,0,1,1-12-12A12,12,0,0,1,184,128Zm-88,0a12,12,0,1,1-12-12A12,12,0,0,1,96,128Z" }, null, -1)
      ]))) : l(a) === "thin" ? (o(), e("g", w, t[5] || (t[5] = [
        n("path", { d: "M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.1,92.1,0,0,1,128,220Zm8-92a8,8,0,1,1-8-8A8,8,0,0,1,136,128Zm-44,0a8,8,0,1,1-8-8A8,8,0,0,1,92,128Zm88,0a8,8,0,1,1-8-8A8,8,0,0,1,180,128Z" }, null, -1)
      ]))) : p("", !0)
    ], 16));
  }
});
export {
  b as default
};
